import tickets from "./tickets";
import beschwerde from "./beschwerde";
import tagesdienstplaene from "./tagesdienstplaene";
import diensterlaeuterungen from "./diensterlaeuterungen";
import user from "./user";
import kategorien from "./kategorien";

export default { tickets, beschwerde, user, kategorien, tagesdienstplaene, diensterlaeuterungen };
